module.exports = __webpack_public_path__ + "img/user-icon.e9e4b792.png";